import { camelCase } from "lodash";
export default {
    name: "breadcrumb",
    props: {
        route: {},
    },
    beforeCreate() {
        this.$options.computed.value = function() {
            if (this.route.bcGetter) {
                return this.$store.getters[`${this.route.bcModule}/${this.route.bcGetter}`];
            } else {
                return null;
            }
        };
    },
    created() {},
    computed: {
        formattedValue() {
            if (this.value) {
                return this.value.title;
            } else {
                return null;
            }
        },
    },
    methods: {
        toCamelCase(val) {
            return camelCase(val);
        },
    },
};
